import type { CoopRelationshipDTO } from '@bb/domain/dist/types';
import axios from 'axios';

const getCoopRelationships = async () => {
  const { data } = await axios.get<CoopRelationshipDTO[]>(
    'supra/coop/relationships/list',
  );

  return data;
};

export default getCoopRelationships;
